export function formatMoney(value: string | number | null | undefined) {
  if (value == null || value === '') return '—'
  const n = typeof value === 'number' ? value : Number(value)
  if (Number.isNaN(n)) return '—'
  return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

export function formatDate(iso?: string | null) {
  if (!iso) return '—'
  const d = new Date(iso.includes('T') ? iso : `${iso}T12:00:00`)
  if (Number.isNaN(d.getTime())) return iso
  return d.toLocaleDateString('pt-BR')
}

export function formatCompetencia(value?: string | null) {
  if (!value) return '—'
  // aceita YYYY-MM ou YYYY-MM-DD
  const m = String(value).match(/^(\d{4})-(\d{2})/)
  if (!m) return value
  return `${m[2]}/${m[1]}`
}
